import * as React from 'react'

const NumberSessonSvg = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#E0EAFF" />
    <path
      d="M27.5 18.3333H12.5M23.3333 11.6666V15M16.6667 11.6666V15M17.5 23.3333L19.1667 25L22.9167 21.25M16.5 28.3333H23.5C24.9001 28.3333 25.6002 28.3333 26.135 28.0608C26.6054 27.8211 26.9878 27.4387 27.2275 26.9683C27.5 26.4335 27.5 25.7334 27.5 24.3333V17.3333C27.5 15.9332 27.5 15.2331 27.2275 14.6983C26.9878 14.2279 26.6054 13.8455 26.135 13.6058C25.6002 13.3333 24.9001 13.3333 23.5 13.3333H16.5C15.0999 13.3333 14.3998 13.3333 13.865 13.6058C13.3946 13.8455 13.0122 14.2279 12.7725 14.6983C12.5 15.2331 12.5 15.9332 12.5 17.3333V24.3333C12.5 25.7334 12.5 26.4335 12.7725 26.9683C13.0122 27.4387 13.3946 27.8211 13.865 28.0608C14.3998 28.3333 15.0999 28.3333 16.5 28.3333Z"
      stroke="#444CE7"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default NumberSessonSvg
